import { render, staticRenderFns } from "./LibraryCollection.vue?vue&type=template&id=5ea5187f&scoped=true&"
import script from "./LibraryCollection.vue?vue&type=script&lang=js&"
export * from "./LibraryCollection.vue?vue&type=script&lang=js&"
import style0 from "./LibraryCollection.vue?vue&type=style&index=0&id=5ea5187f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea5187f",
  null
  
)

export default component.exports